import tyrannosaurusSkeleton from '@worklist-2/ui/src/assets/img/tyrannosaurusSkeleton.png';
import humanSkeleton from '@worklist-2/ui/src/assets/img/humanSkeleton.png';
import Snake from '@worklist-2/ui/src/assets/img/Snake.png';
import reportA from '@worklist-2/ui/src/assets/pdf/_DANNY DEMO BEEBOPP.pdf';
import reportC from '@worklist-2/ui/src/assets/pdf/Sarah_CT.pdf';
import reportD from '@worklist-2/ui/src/assets/pdf/Sarah_Mammo.pdf';
import reportE from '@worklist-2/ui/src/assets/pdf/Sarah_XRAY.pdf';

const imagingOrgData = {
	id: 0,
	name: 'RamRad Imaging Center',
	address: null,
	latLong: null,
	phone: '+1 (888) 343-9146',
};

const managingOrgData = {
	id: 1,
	name: 'RAMSOFT',
	address: null,
	latLong: null,
	phone: '+1 (888) 343-9146',
};

const demoSeriesInfo = {
	internalOrganizationID: 1,
	series: [
		{
			uid: 'DEMO_29008.290080.1544096304',
			instance: [
				{
					uid: 'DEMO_29008.290080.1544096304.290081.1544096304',
				},
			],
		},
	],
};

const shareInfoDict = {
	phone: null,
	permission: 'View Only',
	timeToLive: null,
	isSeen: null,
	initialShared: null,
	sharedBy: null,
};

const sharedInfo = [
	{
		name: 'Test A',
		email: 'testa@gmail.com',
		...shareInfoDict,
	},
	{
		name: 'Test B',
		email: 'testb@gmail.com',
		...shareInfoDict,
	},
	{
		name: 'Test C',
		email: 'testc@gmail.com',
		...shareInfoDict,
	},
	{
		name: 'Test D',
		email: 'testd@gmail.com',
		...shareInfoDict,
	},
	{
		name: 'Test E',
		email: 'teste@gmail.com',
		...shareInfoDict,
	},
	{
		name: 'Test F',
		email: 'testf@gmail.com',
		...shareInfoDict,
	},
];

const pdfData =
	'data:application/pdf;base64,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';

const demoStudyInfo = {
	modality: 'XR',
	laterality: 'Left',
	bodyPart: 'Whole',
	department: 'Radiology',
	referringPhysician: 'Dr David King',
	relevantArticles: [],
	resourceType: 'BlumeStudy',
	telecom: [],
	managingOrganization: managingOrgData,
	isActive: true,
};

export const STUDY_DATA = [
	{
		patientId: '12345',
		status: 'COMPLETED',
		loincCode: '00987',
		description: 'Dino',
		studyType: '6661',
		scanDate: '10/11/2022 08:30:00',
		studyID: '123546576',
		reports: [
			{
				reportId: '847',
				doctorName: null,
			},
		],
		sharedInformation: sharedInfo.slice(0, 2),
		studyThumbnail: {
			studyUID: 'dummy12345',
			sopInstanceUID: null,
			seriesUID: null,
		},
		id: '12345',
		imagingOrganization: imagingOrgData,
		...demoStudyInfo,
	},
	{
		patientId: '98765',
		status: 'COMPLETED',
		loincCode: '00986',
		description: 'Snake',
		studyType: '6662',
		scanDate: '10/11/2022 13:04:00',
		studyID: '10938638',
		reports: [
			{
				reportId: '847',
				doctorName: null,
			},
		],
		sharedInformation: sharedInfo.slice(2, 4),
		studyThumbnail: {
			studyUID: 'dummy12346',
			sopInstanceUID: null,
			seriesUID: null,
		},
		id: '12346',
		imagingOrganization: imagingOrgData,
		...demoStudyInfo,
	},
	{
		patientId: '49863',
		status: 'COMPLETED',
		loincCode: '00985',
		description: 'Human Skeleton',
		studyType: '6663',
		scanDate: '10/11/2022 16:36:00',
		studyID: '985378256',
		reports: [
			{
				reportId: '847',
				doctorName: null,
			},
		],
		sharedInformation: sharedInfo.slice(2, 6),
		studyThumbnail: {
			studyUID: 'dummy12347',
			sopInstanceUID: null,
			seriesUID: null,
		},
		id: '12347',
		imagingOrganization: {
			...imagingOrgData,
			name: "RamSoft Women's Imaging Center",
		},
		...demoStudyInfo,
	},
	{
		patientId: '60',
		status: 'INPROCESS',
		loincCode: '00984',
		description: 'IV CONTRAST',
		studyType: '6664',
		scanDate: '10/11/2022 19:00:00',
		studyID: 'DEMO_001',
		reports: [null],
		sharedInformation: sharedInfo,
		studyThumbnail: {
			studyUID: 'dummy12348',
			sopInstanceUID: null,
			seriesUID: null,
		},
		id: '12348',
		imagingOrganization: imagingOrgData,
		...demoStudyInfo,
	},
];

export const SERIES_DATA = [
	{
		id: '12345',
		uid: 'dummy12345',
		...demoSeriesInfo,
	},
	{
		id: '12346',
		uid: 'dummy12346',
		...demoSeriesInfo,
	},
	{
		id: '12347',
		uid: 'dummy12347',
		...demoSeriesInfo,
	},
	{
		id: '12348',
		uid: 'dummy12348',
		...demoSeriesInfo,
	},
];

export const STUDY_IMAGE_DATA = {
	dummy12345: tyrannosaurusSkeleton,
	dummy12346: Snake,
	dummy12347: humanSkeleton,
};

export const REPORT_DATA = {
	12345: [
		{
			id: 0,
			selected: false,
			reportName: 'DANNY DEMO BEEBOPP',
			doctorName: 'Dr. DEMO',
			reportPath: reportA,
			reportId: 'DEMO_REP001',
		},
	],
	12346: [
		{
			id: 0,
			selected: false,
			reportName: 'DANNY DEMO BEEBOPP',
			doctorName: 'Dr. DEMO',
			reportPath: reportA,
			reportId: 'DEMO_REP002',
		},
	],
	12347: [
		{
			id: 0,
			selected: false,
			reportName: 'Sarah CT',
			doctorName: 'Dr. John',
			reportPath: reportC,
			reportId: 'DEMO_REP003',
			scansLatedLink: 'https://scanslated.com/sample-reports/abdom.html',
		},
		{
			id: 1,
			selected: false,
			reportName: 'Sarah Mammo',
			doctorName: 'Dr. Jenny',
			reportPath: reportD,
			reportId: 'DEMO_REP004',
			scansLatedLink: 'https://scanslated.com/sample-reports/mammo.html',
		},
		{
			id: 1,
			selected: false,
			reportName: 'Sarah X-Ray',
			doctorName: 'Dr. Sam',
			reportPath: reportE,
			reportId: 'DEMO_REP004',
			scansLatedLink: 'https://scanslated.com/sample-reports/chest.html',
		},
	],
	12348: [],
};
